export default __webpack_public_path__ + "static/media/TallyIntegration.2a16d469.png";